package top.wcpe.allincore.ui.runtime.theme

import top.wcpe.allincore.ui.runtime.animation.Easing

/**
 * 主题切换过渡：在 from→to 两套 [ControlTheme] 之间按时长插值，供 `local.setTheme` 平滑换肤。
 * 不可变、纯函数，由 `RendererRegistry` 在每帧读取主题时按当前时间采样。
 *
 * 采样在「读侧」进行：渲染入口每帧调用 `controlTheme()` 时若存在进行中的过渡，则返回
 * [ControlTheme.lerp] 合成的逐帧主题；过渡结束（[isDone]）落定为 to。
 *
 * @param easing 缓动曲线，null 时回退默认 [Easing.EASE_IN_OUT_CUBIC]
 */
class ThemeTransition(
    private val from: ControlTheme,
    private val to: ControlTheme,
    private val startMs: Long,
    private val durationMs: Long,
    easing: Easing?,
) {

    private val easing: Easing = easing ?: Easing.EASE_IN_OUT_CUBIC

    /** 目标主题（过渡终点）。 */
    fun target(): ControlTheme = to

    /** 按当前时间采样合成主题；durationMs<=0 立即返回 to，最后一帧精确落在 to。 */
    fun sample(nowMs: Long): ControlTheme {
        if (durationMs <= 0) return to
        val raw = (nowMs - startMs) / durationMs.toDouble()
        if (raw <= 0.0) return from
        if (raw >= 1.0) return to
        return ControlTheme.lerp(from, to, easing.apply(raw))
    }

    /** 过渡是否已结束（可落定为 to）。 */
    fun isDone(nowMs: Long): Boolean = durationMs <= 0 || nowMs - startMs >= durationMs

    companion object {
        /** 默认过渡时长（毫秒），对齐 MD3 中等动效（约 200ms）。 */
        const val DEFAULT_DURATION_MS = 200L
    }
}
